import React, { FunctionComponent, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import {useNavigate} from "react-router-dom";
import { Tooltip } from 'reactstrap';
import { Props } from './ServiceCard.interface';
import {
  StCardText,
  StIconArrow,
  StIconInfo,
  StyledCard,
  StyledCardBody,
  StyledCardImg,
  StyledCardTitle,
} from './ServiceCard.style';

const ServiceCard: FunctionComponent<Props> = props => {
  const { title, logo, pushPath } = props;
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const navigate = useNavigate();

  const toggle = () => setTooltipOpen(!tooltipOpen);
  const goToServicePage = () => {
    navigate({pathname: pushPath});
  };

  return (
    <StyledCard key={`key-${title}`} onClick={goToServicePage} className='col mb-4'>
      <StyledCardImg className={`icon icon-md`}>
        {logo === 'smartBuildingServiceLogo'
          ? 'domain'
          : logo === 'localisationServiceLogo'
          ? 'place'
          : logo === 'desksServiceLogo'
          ? 'desktop_windows'
          : logo === 'reservationLogo'
          ? 'event'
          : 'assessment'}
      </StyledCardImg>
      <StyledCardTitle>
        <FormattedMessage id={`servicesTitles.${title}`} />
      </StyledCardTitle>
      <StyledCardBody>
        <StCardText key={`tooltip${title}`} id={`tooltip${title}`}>
          <StIconInfo className={`icon icon-md`}>info_outline</StIconInfo>
          <Tooltip
            isOpen={tooltipOpen}
            target={`tooltip${title}`}
            toggle={toggle}
          >
            <FormattedMessage id={`servicesDescription.${title}`} />
          </Tooltip>
        </StCardText>
        <StCardText key={`tooltip${pushPath}`} id={`tooltip${title}`}>
          <StIconArrow className={`icon icon-md `}>arrow_forward</StIconArrow>
        </StCardText>
      </StyledCardBody>
    </StyledCard>
  );
};

export default ServiceCard;
